<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="true"
      :hasFilter="true"
      :title="$lang.hozeh_ghazayi_list"
      :url="url"
      :html="false"
      ref="searchParvandeh"
      @updatePermissions="updatePermissions"
      :hasAdd="true"
      @handleAdd="showAddModal"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="py-1 mb-3 border-bottom d-md-flex d-block align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <span
              class="mr-1 fs_1_3rem w_h_35 border bg-light rounded-circle d-flex align-items-center justify-content-center text-primary"
            >
              <mdicon name="map-marker-account" color="red" />
            </span>
            <b class="px-1 fs_1rem" v-html="generateParvandehTitle(item)" />
          </div>
          <small
            class="text-muted d-md-block d-flex align-items-center justify-content-between"
          >
            <div
              v-b-tooltip
              title="ثبت کننده"
              v-if="
                pathOr(null, ['created_by'], item) &&
                pathOr(null, ['created_by'], item) !== getFullName(item)
              "
            >
              <i class="fas fa-user mr-1" />
              <span v-text="pathOr('', ['created_by'], item)" />
            </div>
            <div v-b-tooltip title="زمان ایجاد">
              <i class="fas fa-clock mr-1" />
              <span v-text="pathOr('', ['created_at', 'jalali'], item)" />
            </div>
          </small>
        </b-col>
        <b-col cols="12" md="12">
          <b-row>
            <b-col cols="12" md="12" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.profileLang.term_title" />:
              <span
                class="text-muted"
                v-text="pathOr(null, ['parvandeh', 'term', 'caption'], item)"
              />
            </b-col>
            <b-col cols="12" md="7" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.name_family" />:
              <ProfileBoxPopupWrapper
                :data="item"
                deskTopPopupClass="top-230"
                nameClass="color-complementary"
              />
            </b-col>
            <b-col cols="12" md="5" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.national_code" />:
              <span
                class="text-muted"
                v-text="pathOr(null, ['person', 'national_code'], item)"
              />
            </b-col>
            <b-col cols="12" md="7" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.hozeh_ghazayi_name" />:
              <span class="text-muted" v-text="getHozeh(item)" />
            </b-col>
            <b-col
              v-if="pathOr(null, ['status', 'id'], item) !== 5"
              cols="12"
              md="7"
              class="py-1"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.num_editable" />:
              <span
                class="text-muted"
                v-text="pathOr(null, ['max_edit_count'], item)"
              />
            </b-col>
            <b-col
              v-if="pathOr(null, ['status', 'id'], item) !== 5"
              cols="12"
              md="5"
              class="py-1"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.num_edited" />:
              <span
                class="text-muted"
                v-text="pathOr(null, ['edit_count'], item)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="12" class="py-1 mt-3 border-top">
          <b-row align-v="center" align-h="between" class="w-100 m-0">
            <b-col cols="12" md="auto" class="px-0" />
            <b-col cols="12" md="" class="text-right px-0">
              <b-button
                v-if="isAdmin(permissions) && isFiveStatus(item)"
                class="mr-2"
                variant="outline-success"
                size="sm"
                @click="showEditModal(item)"
              >
                <mdicon name="playlist-edit" size="20" />
                <b v-text="$lang.edit" class="ml-1" />
              </b-button>
              <b-button
                v-if="isAdmin(permissions) && !isFiveStatus(item)"
                class="mr-2"
                variant="outline-warning"
                size="sm"
                @click="showResetConfirm(item)"
              >
                <mdicon name="circle-edit-outline" size="20" />
                <b v-text="$lang.reedit" class="ml-1" />
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="addEditModal"
      size="lg"
      ok-only
      hide-footer
      hide-header
    >
      <AddHozehGhazayi
        v-if="addEditModalMode === 'add'"
        :parentPermissions="permissions"
        @close="addEditModal = false"
        @getData="getData"
      />
      <EditHozehGhazayi
        v-if="addEditModalMode === 'edit'"
        :parentPermissions="permissions"
        :id="parvandehCode"
        @close="addEditModal = false"
        @getData="getData"
      />
    </b-modal>
    <Confirm
      :title="$lang.reedit"
      :description="reeditConfirmCaption"
      v-model="resetConfirmModel"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      dynamicClass=""
      :loadingSpinnerText="$lang.updating_data"
      :loading="resetConfirmLoading"
      :preventDefault="true"
      @ok="resetEditable()"
      @cancel="resetConfirmModel = false"
    />
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import SearchCard from "@/components/base/searchCard";
import { pathOr } from "ramda";
import AddHozehGhazayi from "./components/AddHozehGhazayi.vue";
import EditHozehGhazayi from "./components/EditHozehGhazayi.vue";
import Confirm from "@/components/base/confirm";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "search-hozeh-gazayi",
  inject: ["hozehGhazayiRepository"],
  components: {
    SearchCard,
    AddHozehGhazayi,
    EditHozehGhazayi,
    Confirm,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      addEditModal: false,
      resetId: null,
      resetConfirmLoading: false,
      resetConfirmModel: false,
      addEditModalMode: "add",
      parvandehCode: null,
      permissions: [],
    };
  },
  computed: {
    reeditConfirmCaption() {
      return `با انجام این کار <b class='text-primary'>تعداد دفعات ویرایش شده</b> این رکورد <b class='text-primary'>0</b> خواهد شد
      <br><br><b>آیا از اجرای فرایند اطمینان دارید ؟</b>`;
    },
    url() {
      return generateApiUrl(["profile", "all_hozeh_ghazayi"]);
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    getHozeh(item) {
      const province = pathOr("", ["hozeh_ghazayi_province", "caption"], item);
      const detail = pathOr("", ["hozeh_ghazayi_detail", "caption"], item);
      const priority = pathOr("", ["priority"], item);
      return `استان ${province} ${detail}(اولویت ${priority})`;
    },
    getData() {
      this.$refs.searchParvandeh.getItems();
    },
    generateParvandehTitle(item) {
      const parvandeh_number = pathOr(
        "",
        ["parvandeh", "parvandeh_number"],
        item
      );
      const status = pathOr("", ["status", "caption"], item);
      const parvandehHref = this.$router.resolve({
        name: "parvandeh_by_number",
        params: { parvandeh_number },
      }).href;
      return `پرونده <a href='${parvandehHref}' target='_blank'>${parvandeh_number}</a> - ${status}`;
    },
    showAddModal() {
      this.addEditModalMode = "add";
      this.addEditModal = true;
    },
    showEditModal(item) {
      this.addEditModalMode = "edit";
      this.parvandehCode = pathOr(null, ["parvandeh", "code"], item);
      this.addEditModal = true;
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    getFullName(item) {
      const name = pathOr("", ["person", "name"], item);
      const family = pathOr("", ["person", "family"], item);
      return `${name} ${family}`;
    },
    isFiveStatus(item) {
      return pathOr(null, ["status", "id"], item) === 5;
    },
    showResetConfirm(item) {
      this.resetId = pathOr(null, ["id"], item);
      this.resetConfirmModel = true;
    },
    async resetEditable() {
      try {
        this.resetConfirmLoading = true;
        const response = await this.hozehGhazayiRepository.partial_edit(
          this.resetId
        );
        this.$notify.success(response.data.message);
        this.resetConfirmModel = false;
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.resetConfirmLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.grid-img-crd {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  img {
    width: 95px;
    height: auto;
  }
}
.fs_1_3rem {
  font-size: 20px;
}
.w_h_35 {
  width: 35px;
  height: 35px;
}
</style>
